import { FC } from "react"

import { css, Theme } from "@emotion/react"
import { Link } from "@material-ui/core"
import { menuContainerStyle, navItemListStyle } from "./style"

export interface ShopBarNavSubmenuProps {
	items: {
		label: string | number
		onClickValue: string | number
	}[]
	onClick: (itemValue: string) => void
	columnCount?: number
}

export const ShopBarNavSubmenu: FC<ShopBarNavSubmenuProps> = ({ items, onClick, columnCount }) => {
	return (
		<div css={menuContainerStyle}>
			<ul
				className="navItemListStyle"
				css={[
					navItemListStyle,
					css`
						column-count: ${columnCount ?? 3};
					`,
				]}
			>
				{items.map((item) => (
					<li key={item.onClickValue}>
						<Link onClick={() => onClick(item.onClickValue.toString())}>
							{item.label}
						</Link>
					</li>
				))}
			</ul>
		</div>
	)
}
